import React from 'react';
import styles from './opener.module.scss';

const ColorPickerOpener = ({ color, onClick }) => {
	return (
		<div onClick={onClick}
			className={styles.container}
			style={{
				backgroundColor: color,
				// if there is no color, show border
				borderColor: color === undefined ? '' : 'transparent'
			}}
		/>
	);
}

export default ColorPickerOpener;
